import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  exports: [MatDialogModule],
})
export class MaterialModule {}
